const post2 = {
  id: 2,
  directory: 'simple-weather',
  publishDate: '3-4-2019',
  mediaType: 'image',
  catagories: [],
  ImageThumb: '2-weather-app-thumb.png',
  ImageLarge: 'https://picsum.photos/900/400/?image=20',
  shortDescription: 'React Context App',
  description: 'description of post',
  url: 'http://www.andressbarnes.com',
  body:
    '<h1>Coffee and code from the bean heads.</h1><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>'
};

export default post2;
